var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Grid, Header } from "semantic-ui-react";
import { KitDisplayModal } from "./admin/SingleOrderPage";
import { discountMessage, formatMonetaryDecimal } from "./kit/rna-fish/EditKitForm";
import KitDisplay from "./kit/rna-fish/KitDisplay";
import { addressGridRows } from "./ProfilePage";
var QuoteDisplay = /** @class */ (function (_super) {
    __extends(QuoteDisplay, _super);
    function QuoteDisplay(props) {
        return _super.call(this, props) || this;
    }
    QuoteDisplay.prototype.render = function () {
        return React.createElement("div", { className: 'quote-display' },
            React.createElement(Header, null, "Items"),
            React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                this.props.quote.items.map(function (item, index) {
                    return React.createElement(Grid.Row, { key: index },
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            "Kit #",
                            index + 1,
                            " ",
                            React.createElement(KitDisplayModal, { admin: false, itemIndex: index, pricedKit: item, trigger: React.createElement(Button, { icon: 'eye', size: 'mini' }) })),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(item.price.subtotalCents)));
                }),
                displaySubtotalRows(this.props.quote.subtotalCents, this.props.quote)),
            React.createElement("div", { style: { marginTop: '1rem' } }, discountMessage(this.props.quote.discountCents, this.props.quote.listPriceSubtotalCents)),
            displayShippingBillingInfo(this.props.quote));
    };
    return QuoteDisplay;
}(React.PureComponent));
export default QuoteDisplay;
export var displaySubtotalRows = function (subtotalCents, quote) {
    return React.createElement(React.Fragment, null,
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                React.createElement(Header, null, "Order Subtotal")),
            React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                React.createElement(Header, null,
                    "$",
                    formatMonetaryDecimal(subtotalCents)))),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Estimated Shipping"),
            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, quote.shippingCostEstimate ? "$" + formatMonetaryDecimal(quote.shippingCostEstimate) : "TBD")),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Handling & Packaging"),
            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, "$" + formatMonetaryDecimal(quote.handlingAndDryIce))),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Sales Tax"),
            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, "TBD")));
};
var displayShippingBillingInfo = function (q) {
    return React.createElement(React.Fragment, null,
        React.createElement(Header, null, "Shipping Info"),
        React.createElement(Grid, { className: 'tight-rows' },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Recipient"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, q.userName)),
            addressGridRows(q.shippingAddress, KitDisplay.labelWidth, KitDisplay.valueWidth),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Recipient email"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, q.userEmail)),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Recipient phone"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, q.userPhone))),
        React.createElement(Header, null, "Billing Info"),
        React.createElement(Grid, { className: 'tight-rows' },
            addressGridRows(q.billingAddress, KitDisplay.labelWidth, KitDisplay.valueWidth),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Billing email"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, q.billingEmail)),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Billing phone"),
                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, q.billingPhone))));
};
//# sourceMappingURL=QuoteDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/QuoteDisplay.js
// module id = 545
// module chunks = 0